/**
 * Las cuentas del adaptador local. **Son de mentira y están a la vista.**
 *
 * Que estén en el repo, en claro, no es un descuido: es lo que hace honesto el
 * login de desarrollo. La pantalla lo anuncia con `AvisoDeDatos`, el mismo
 * componente que usa `/demo`, y el puerto lo expone con `esDeMentira`.
 *
 * **Nada de esto vale nada en producción.** Cuando `elPuerto.ts` devuelva el
 * adaptador de `capital`, este archivo deja de importarse y sólo queda en las
 * pruebas. No hay riesgo de que una de estas contraseñas «se quede»: no viajan
 * a ningún servidor, porque no hay servidor.
 *
 * Dos detalles que parecen cosméticos y no lo son:
 *
 * - **Los dominios son `.test`**, que es un TLD reservado por la RFC 2606 y no
 *   se puede registrar. Un `@ejemplo.com` es de alguien.
 * - **Aquí no hay prosa en español.** Correos, nombres propios y contraseñas
 *   pueden vivir en el código; una frase dirigida a una persona no, y
 *   `sinTextoEnDuro.test.ts` se pone rojo si aparece. Lo que hay que decirle a
 *   quien mira la pantalla está en el diccionario.
 */

export interface CuentaDeMentira {
  correo: string;
  contrasena: string;
  id: string;
  nombre: string | null;
  /**
   * Las dos cuentas de mentira son `inversionista`, y a propósito.
   *
   * La pantalla de administración no se puede probar en local de todas formas
   * --el adaptador de datos local no tiene cuentas que listar y lanza
   * `sinConfigurar`--, así que una cuenta de mentira con rol de administrador
   * sólo serviría para pintar una pantalla que se cae al entrar. Peor: daría la
   * impresión de que el rol se reparte aquí, y el rol lo decide el servidor.
   */
  rol: string;
}

export const CUENTAS_DE_MENTIRA: readonly CuentaDeMentira[] = [
  {
    correo: 'inversionista@ejemplo.test',
    contrasena: 'demo1234',
    id: 'inv-001',
    nombre: 'Renata Aguilar',
    rol: 'inversionista',
  },
  {
    // La segunda existe para que se pueda probar que cerrar sesión de una no
    // toca a la otra, y que el panel saluda por su nombre y no por el primero
    // de la lista.
    correo: 'fondo@ejemplo.test',
    contrasena: 'demo1234',
    id: 'inv-002',
    nombre: null,
    rol: 'inversionista',
  },
];
